import { createSlice } from "@reduxjs/toolkit";
import { getAgents } from "./AgentDetailsAction";
import { IAgentDetailsSlice } from "./AgentDetails.types";

const initialState: IAgentDetailsSlice = {
  agentDetails: [],
};

const AgentSlice = createSlice({
  name: "agents",
  initialState: initialState,
  reducers: {
    setagentDetails: (state, { payload }) => {
      state.agentDetails = payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAgents.fulfilled, (state, { payload }) => {
      state.agentDetails = payload.data || [];
    });
  },
});

export default AgentSlice.reducer;
export const { setagentDetails } = AgentSlice.actions;
